<template> 
  <section v-if="variants.v1 === variant" class="hero-area section-padding" 
   :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-xl-7 col-lg-7 col-md-7 col-sm-9">
                    <div class="section-title">
                        <div class="heading-animation">
                            <h1>
  <svg
    v-if="vars.isVisibleBool"
    width="1em"
    height="1em"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="flex-shrink-0"
    style="display: inline;"
  >
    <rect width="40.9678" height="40.9678" fill="#E4002B"/>
    <circle cx="12.7821" cy="4.69764"  r="2.18495" fill="white"/>
    <circle cx="28.5136" cy="4.69764"  r="2.18495" fill="white"/>
    <circle cx="36.161"  cy="9.94151"  r="2.18495" fill="white"/>
    <circle cx="20.6478" cy="9.94151"  r="2.18495" fill="white"/>
    <circle cx="5.13465" cy="9.94151"  r="2.18495" fill="white"/>
    <circle cx="12.7821" cy="15.2946"  r="2.18495" fill="white"/>
    <circle cx="28.5136" cy="15.2946"  r="2.18495" fill="white"/>
    <circle cx="36.161"  cy="20.5385"  r="2.18495" fill="white"/>
    <circle cx="20.6478" cy="20.5385"  r="2.18495" fill="white"/>
    <circle cx="5.13465" cy="20.5385"  r="2.18495" fill="white"/>
    <circle cx="12.7821" cy="25.8916"  r="2.18495" fill="white"/>
    <circle cx="28.5136" cy="25.8916"  r="2.18495" fill="white"/>
    <circle cx="36.161"  cy="31.1355"  r="2.18495" fill="white"/>
    <circle cx="20.6478" cy="31.1355"  r="2.18495" fill="white"/>
    <circle cx="5.13465" cy="31.1355"  r="2.18495" fill="white"/>
    <circle cx="12.7821" cy="36.4886"  r="2.18495" fill="white"/>
    <circle cx="28.5136" cy="36.4886"  r="2.18495" fill="white"/>
  </svg><span v-if="vars.isVisibleBool">&nbsp;</span>{{ vars.titleText }}
</h1>
                        </div>
                        
                    </div>                    
                </div>
                <div class="col-xl-5 col-lg-5 col-md-5 wow fadeInUp" data-wow-delay=".6s">       
                    <div class="p-animation">
                        <p>{{vars.descriptionText}}</p>
                    </div>             
                    
                </div>
            </div>
        </div>
        <div class="container">

            <div class="hero-img-wrap mt-30 wow fadeInUp  animated" data-wow-delay=".6s">
                 <library-image
          v-if="vars.backgroundImage"
          :src="vars.backgroundImage"
           class="relative tw-w-full tw-h-full object-cover"
        />
            </div>
            
        </div>        
    
 
  </section>

  <section  v-if="variants.v2 === variant" class="contact-section section-padding pt-0  " 
   :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`">
      
        <div class="container">
            <div class="col-xl-12 col-lg-12">
                <div class="mt-40">
                    <h2>{{ vars.titleText }}</h2>
                </div>
            </div>  
            <div class="row justify-content-center mt-60">
                <div class="col-xl-12">
                   <img
          v-if="vars.backgroundImage"
          :src="vars.backgroundImage"
           
           
        />
                </div>                              
            </div>
            </div>
            
              
    
 
  </section>





  
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
export default defineNuxtComponent({
  mixins: [ComponentMixin],

  data() {
    return {
        variants: {
        v1: 'v1',
        v2: 'v2',
      },

      
      isVisible: false,
      
    };
  },

  computed: {
  
  },

  methods: {
    isExternalLink(url: string) {
      return url.includes('http');
    },
  },
});
</script>
